namespace Ir.Components.Workbook.ToolBar.PDFTemplateToolBar {
    interface IPDFTemplateToolBarViewModel {
        buttonOptions: any,
    }

    export function getViewModel(this: IPDFTemplateToolBarViewModel, params: any) {
        this.buttonOptions = {
            hint: 'PDF Templates',
            template: `<i class="ms">format_image_left</i> <span>PDF Templates</span>`,
            disabled: ko.computed(function () {
                let enabled = loggedUser.permissions.editPDFTemplates() || loggedUser.permissions.pdfTemplates();
                return !enabled;
            }),
            onClick(e) {
                Ir.Components.PDFTemplate.PDFTemplateEditor.show();
            }
        }
    }
}